import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";

import Home from "../views/Home.vue";
import Classroom from "../views/Classroom.vue";
import Contact from "../views/Contact.vue";

//programmatically later
import AttendancePeriod from "../components/periods/Attendance.vue";
import MathPeriod from "../components/periods/Math.vue";
import RecessPeriod from "../components/periods/Recess.vue";
import ReadingPeriod from "../components/periods/Reading.vue";
import IReadyPeriod from "../components/periods/IReady.vue";
import LunchPeriod from "../components/periods/Lunch.vue";
import AccellusPeriod from "../components/periods/Accellus.vue";
import TemperatureCheckPeriod from "../components/periods/TemperatureCheck.vue";


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/a202",
    name: "A202",
    component: Classroom,
    meta: {
      requiresAuth: true
    },
    children: [
      { path: '/a202', redirect: '/a202/attendance' },
      { path: '/a202/attendance', component: AttendancePeriod, props: true },
      { path: '/a202/math', component: MathPeriod, props: true },
      { path: '/a202/recess', component: RecessPeriod, props: true },
      { path: '/a202/reading', component: ReadingPeriod, props: true },
      { path: '/a202/iready', component: IReadyPeriod, props: true },
      { path: '/a202/lunch', component: LunchPeriod, props: true },
      { path: '/a202/accellus', component: AccellusPeriod, props: true },
      { path: '/a202/temperature-check', component: TemperatureCheckPeriod, props: true },
    ]
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  console.log("running");
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(store.getters.isUserAuth) {
      console.log('user is auth');
      next()
      return
    }
    next('/') 
  } else {
    next() 
  }
});

export default router;
